<template>
  <div>
    <div class="footer">
      <div class="navfooter">
        <div class="footerleft">
          <div class="footeritem" v-for="item in footerArticle" :key="item.id">
            <div class="navfooterhead">{{ item.title }}</div>
            <ul style="position: relative;">
                <li v-for="value in item.articles" :key="value.id" :class="value.id === 2062 ? 'email-return' : ''">
                  <a :href="articles(value.article_url, value.id)" v-html="value.title" v-if="value.id !== 2062"></a>
                  <div class="email-return-wrapper" v-else>
                    <p>Subscribe to our newsletter to get updates on our latest offers!</p>
                    <div class="input-box">
                      <div class="inner-input">
                        <van-field v-model="email" size="large" left-icon="envelop-o" style="flex: 1;" placeholder="Enter E-mail Address" />
                      </div>

                      <div class="button-box" @click="handleToSubscribeClick">Subscribe</div>
                    </div>
                    <p class="conditions">
                      <van-checkbox v-model="isCheck" icon-size="14px" shape="square">
                        I agree to Kilimall <span class="conditions-label"><a href="/help-center/oh_3467?c_id=1083" target="_blank">Terms & Conditions and Privacy Policy</a></span>
                      </van-checkbox>
                    </p>
                  </div>
                </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #f7f7f7;">
      <div class="stay-connected">
        <p class="title-text">Stay Connected:&nbsp;</p>
        <div class="stay-icons">
          <a href="https://www.facebook.com/kilimall/" target="_blank">
            <img :src="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/footerappad/facebook.png', {w: 180})"
                 alt="">
          </a>
          <a href="https://twitter.com/Kilimall" target="_blank">
            <img :src="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/footerappad/twitter.png', {w: 180})" alt="">
          </a>
          <a href="http://k.kili.co/11zqh" target="_blank">
            <img :src="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/tiktok.png', {w: 180})" alt="">
          </a>
          <a href="http://k.kili.co/11zqk" target="_blank">
            <img :src="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/ins.png', {w: 180})" alt="">
          </a>
        </div>

        <p class="title-text download-app">Download App:&nbsp;</p>
        <a href="https://play.google.com/store/apps/details?id=net.kilimall.shop" target="_blank">
          <img class="google-play-icon"
               :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/google-play-btn@2x.png', { w: 220 })" alt="">
        </a>

        <a :href="regionId === '8' ? 'https://apps.apple.com/ug/app/kilimall/id6470137287' : 'https://apps.apple.com/ke/app/kilimall/id6470137287'" target="_blank">
          <img class="google-play-icon"
               :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/app-store-btn@2x.png', { w: 220 })" alt="">
        </a>
      </div>

      <div class="supportedPayment">
        <div class="bannr">
          <ul class="paymentICONLIST">
            <li>
              <img alt="M-PESA" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_mpesa.png')"/>
            </li>
            <li>
              <img alt="Airtel" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/loge_airtel.png')"/>
            </li>
            <li>
              <img alt="KCB" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_KCB.png')"/>
            </li>
            <li>
              <img alt="Ecobank" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_Ecobank.png')"/>
            </li>
            <li>
              <img alt="CreditBank" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_CreditBank.png')"/>
            </li>
            <li>
              <img alt="Lipapay" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_lipapay.png')"/>
            </li>
            <li>
              <img alt="Visa" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_visa.png')"/>
            </li>
            <li>
              <img alt="Mastercard" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_mastercard.png')"/>
            </li>
            <li>
              <img alt="UnionPay" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_UnionPay.png')"/>
            </li>
            <li>
              <img alt="iPay" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/static/logo_ipay.png')"/>
            </li>
            <li>
              <img alt="McAfee SECURE" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/footerlipalpay/M.png')"/>
            </li>
            <li>
              <img alt="TrustedSite" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/footerlipalpay/T.png')"/>
            </li>
            <li>
              <img alt="SSL Secure" v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/footerlipalpay/S.png')"/>
            </li>
          </ul>
        </div>
      </div>
      <div class="brand-div">
        <div class="brand-item">
          <a class="brand-title" href="/search?q=VITRON">VITRON</a>
          <a class="brand-title" href="/search?q=Lyons">Lyons</a>
          <a class="brand-title" href="/search?q=Volsmart">Volsmart</a>
          <a class="brand-title" href="/search?q=IPCONE">IPCONE</a>
          <a class="brand-title" href="/search?q=Hisense">Hisense</a>
          <a class="brand-title" href="/search?q=GLD">GLD</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=Artel">Artel</a>
          <a class="brand-title" href="/search?q=ECOMAX">ECOMAX</a>
          <a class="brand-title" href="/search?q=SONAR">SONAR</a>
          <a class="brand-title" href="/search?q=RAMTONS">RAMTONS</a>
          <a class="brand-title" href="/search?q=TAGWOOD">TAGWOOD</a>
          <a class="brand-title" href="/search?q=ElectroMate">ElectroMate</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=Eurochef">Eurochef</a>
          <a class="brand-title" href="/search?q=RASHNIK">RASHNIK</a>
          <a class="brand-title" href="/search?q=EOCO">EOCO</a>
          <a class="brand-title" href="/search?q=TCL">TCL</a>
          <a class="brand-title" href="/search?q=Haier">Haier</a>
          <a class="brand-title" href="/search?q=Euroken">Euroken</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=VON">VON</a>
          <a class="brand-title" href="/search?q=SmartPro">SmartPro</a>
          <a class="brand-title" href="/search?q=Rebune">Rebune</a>
          <a class="brand-title" href="/search?q=Garnier">Garnier</a>
          <a class="brand-title" href="/search?q=Maybelline">Maybelline</a>
          <a class="brand-title" href="/search?q=L'oreal+Paris">L'oreal Paris</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=Nice%26Lovely">Nice&Lovely</a>
          <a class="brand-title" href="/search?q=Versman">Versman</a>
          <a class="brand-title" href="/search?q=Nivea">Nivea</a>
          <a class="brand-title" href="/search?q=USN">USN</a>
          <a class="brand-title" href="/search?q=Samsung">Samsung</a>
          <a class="brand-title" href="/search?q=Xiaomi">Xiaomi</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=Tecno">Tecno</a>
          <a class="brand-title" href="/search?q=OPPO">OPPO</a>
          <a class="brand-title" href="/search?q=Apple">Apple</a>
          <a class="brand-title" href="/search?q=Infinix">Infinix</a>
          <a class="brand-title" href="/search?q=itel">itel</a>
          <a class="brand-title" href="/search?q=realme">realme</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=Honor">Honor</a>
          <a class="brand-title" href="/search?q=vivo">vivo</a>
          <a class="brand-title" href="/search?q=Oraimo">Oraimo</a>
          <a class="brand-title" href="/search?q=Lenovo">Lenovo</a>
          <a class="brand-title" href="/search?q=HP">HP</a>
          <a class="brand-title" href="/search?q=ASUS">ASUS</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=TC">TC</a>
          <a class="brand-title" href="/search?q=JAZA+KEJA">JAZA KEJA</a>
          <a class="brand-title" href="/search?q=Jamespot">Jamespot</a>
          <a class="brand-title" href="/search?q=SUNDABESTS">SUNDABESTS</a>
          <a class="brand-title" href="/search?q=Signature">Signature</a>
          <a class="brand-title" href="/search?q=Nice+One">Nice One</a>
        </div>
        <div class="brand-item">
          <a class="brand-title" href="/search?q=Rashnik">Rashnik</a>
          <a class="brand-title" href="/search?q=Edenberg">Edenberg</a>
          <a class="brand-title" href="/search?q=Mimi+Home">Mimi Home</a>
          <a class="brand-title" href="/search?q=Superfoam">Superfoam</a>
          <a class="brand-title" href="/search?q=Vivo+mattress">Vivo mattress</a>
          <a class="brand-title" href="/search?q=Fortress+Mattress">Fortress Mattress</a>
        </div>
      </div>
      <div class="copyright">
        <p style="margin-bottom: 5px;">
          <a :href="currentHost + '/'">MALL</a>&nbsp; |
          <a target="_blank" href="https://seller.kilimall.ke/login">&nbsp;SELLER</a>
          &nbsp; |
          <a href="https://play.google.com/store/apps/details?id=net.kilimall.shop">&nbsp; MOBILE APP</a>
        </p>Copyright {{ yearTime }}
        <a :href="currentHost + '/'" target="_blank">Kilimall</a>, All rights reserved.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { subscribeEmail } from '@/api/models/system'

const regionId = useCurrentCountry().value ? useCurrentCountry().value.toString() : '6'
const currentHost = useCurrentHost()
const yearTime = new Date().getFullYear()
// 页脚数据，先写死
const footerArticle: any[] = [
  {
    "id": 2,
    "parent_id": 0,
    "title": "Shopping Guide",
    "name": "底部导航",
    "description": "Teach you how to online shopping in Kilimall, Kilimall offer the best price on smartphones, electronics, dress, shirt, shoes, home and living, TV in Kenya, buy now!",
    "order": 39,
    "count": 0,
    "keywords": "shoppers guide,buyers guide,kilimall shopping guide",
    "url": "/shopping-guide/",
    "articles": [
      {
        "author": "CS",
        "name": "payment",
        "title": "How do I pay on Kilimall?",
        "class_id": 2,
        "id": 2327,
        // "article_url": "https://helpcenter.kilimall.com/help-center/detail/2448?cid=4&aid=96"
        "article_url": "/help-center/oh_3448?s_id=1004&bs_type=1&c_id=1096"
      },
      {
        "author": "CS",
        "name": "Flash sale",
        "title": "Flash Sale",
        "class_id": 2,
        "id": 2326,
        // "article_url": "https://helpcenter.kilimall.com/help-center/detail/2503?cid=4&aid=96 "
        "article_url": "/help-center/oh_3503?c_id=1096&s_id=1004&bs_type=1"
      },
      {
        "author": "CS",
        "name": "CS",
        "title": "How to apply aftersale/ Refund",
        "class_id": 2,
        "id": 2323,
        "article_url": "/help-center/oh_3445?s_id=1004&bs_type=1&c_id=1098"
      },
      {
        "author": "CS",
        "name": "how long",
        "title": "how long does my order arrive?(Redirection)",
        "class_id": 2,
        "id": 2322,
        "article_url": "/help-center/oh_3438?s_id=1004&bs_type=1&c_id=10"
      },
      {
        "author": "system",
        "name": null,
        "title": "How to shop on Kilimall",
        "class_id": 2,
        "id": 2049,
        "article_url": "/help-center/oh_3441?s_id=1004&bs_type=1&c_id=1096"
      },
      {
        "author": "system",
        "name": null,
        "title": "Forgot Password?",
        "class_id": 2,
        "id": 2052,
        "article_url": "/help-center/oh_3478?s_id=1004&bs_type=1&c_id=1096"
      }
    ]
  },
  {
    "id": 3,
    "parent_id": 0,
    "title": "Customer Help Center",
    "name": "底部导航",
    "description": "Help you solve the problems you encounter at Kilimall, make you happy shopping in Kilimall Kenya.",
    "order": 29,
    "count": 0,
    "keywords": "help center,kilimall help center,kilimall help",
    "url": "/help-center/",
    "articles": [
      {
        "author": "CS",
        "name": "Dispute",
        "title": "Dispute resolution policy",
        "class_id": 3,
        "id": 2328,
        "article_url": "/help-center/oh_3482?s_id=1004&bs_type=1&c_id=1096"
      },
      {
        "author": "system",
        "name": null,
        "title": "Privacy Policy",
        "class_id": 3,
        "id": 3467,
        "article_url": "/help-center/oh_3467?c_id=1083&s_id=1004&bs_type=1"
      },
      {
        "author": "system",
        "name": null,
        "title": "Terms and Conditions",
        "class_id": 3,
        "id": 2126,
        "article_url": "/help-center/oh_3537?c_id=1083&s_id=1004&bs_type=1"
      },
      {
        "author": "system",
        "name": null,
        "title": "Account Settings",
        "class_id": 3,
        "id": 2057,
        "article_url": "/help-center/home?s_id=1004&bs_type=1&c_id=1087"
      },
      {
        "author": "system",
        "name": null,
        "title": "After Sale Policy",
        "class_id": 3,
        "id": 2053,
        "article_url": "/help-center/oh_3348?s_id=1004&bs_type=1&c_id=1087"
      },
      {
        "author": "system",
        "name": null,
        "title": "Delivery and Shipping",
        "class_id": 3,
        "id": 2054,
        "article_url": "/help-center/home?s_id=1004&bs_type=1&c_id=1085"
      },
      {
        "author": "system",
        "name": null,
        "title": "FAQ Center",
        "class_id": 3,
        "id": 2058,
        "article_url": "/help-center/home?s_id=1004&bs_type=1&c_id=1020"
      }
    ]
  },
  {
    "id": 4,
    "parent_id": 0,
    "title": "Business",
    "name": "system",
    "description": null,
    "order": 1,
    "count": 0,
    "keywords": null,
    "url": null,
    "articles": [
      {
        "author": "system",
        "name": null,
        "title": "Want to be a seller?",
        "class_id": 4,
        "id": 2151,
        "article_url": "https://seller.kilimall.ke/create-seller-account/step1"
      },
      {
        "author": "system",
        "name": null,
        "title": "Seller University",
        "class_id": 4,
        "id": 2062,
        "article_url": "/help-center/home?s_id=1006&bs_type=2&c_id=1149"
      },
      {
        "author": "system",
        "name": null,
        "title": "KiliShop",
        "class_id": 4,
        "id": 2061,
        // "article_url": "https://webstore.kilimall.ke/kilipartner-apply"
        "article_url": "https://webstore.kilimall.ke/kilipartner-apply/"
      },
      {
        "author": "system",
        "name": null,
        "title": "KiliJob",
        "class_id": 4,
        "id": 2063,
        // "article_url": "https://webstore.kilimall.ke/kilipartner-apply"
        "article_url": "https://www.kilijob.com/"
      },
      {
        id: 200001
      }
    ]
  },
  {
    "id": 5,
    "parent_id": 0,
    "title": "Kilimall International",
    "name": "底部导航",
    "description": "Kilimall is currently operating in three countries, Kenya, Uganda, Nigeria.",
    "order": 40,
    "count": 0,
    "keywords": "kilimall,kilimall kenya,kilimall international",
    "url": "/kilimall-international/",
    "articles": [
      {
        "author": "system",
        "name": "root",
        "title": "Contact Us",
        "class_id": 5,
        "id": 2066,
        "article_url": "/help-center/oh_3481?c_id=1020"
      },
      {
        "author": "system",
        "name": "Kenya",
        "title": "Kenya",
        "class_id": 5,
        "id": 2085,
        "article_url": currentHost
      },
      {
        "author": "system",
        "name": "Sitemap",
        "title": "Sitemap",
        "id": 2088,
        "article_url": "/sitemap.html"
      }
    ]
  }
]

const articles = (url: string, id: number | string) => {
  if (url == '') {
    return "help/article/" + id
  } else {
    return url
  }
}

const email = ref<string>('')
const isCheck = ref<boolean>(false)
const handleToSubscribeClick = async () => {
  if(!isCheck.value) {
    return showToast('Please agree to the terms and conditions.')
  }
  if(!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(email.value)) {
    return showToast('Please enter a valid email address.')
  }

  try {
    await subscribeEmail(email.value)
    showToast('You have successfully subscribed to our marketing emails!')
  } catch (error) {
    console.error(error)
  }
}
</script>

<style lang="scss" scoped>
ul li {
  list-style: none;
  position: relative;
}
.email-return{
  position: absolute;
  left: 0;
  top: 180px;
  padding: 10px 0;
  width: 800px;
  font-size: 24px;
  z-index: 9;
  &:hover{
    text-decoration: none !important;
  }
  .email-return-wrapper{
    p {
      line-height: 36px;
      margin: 30px 0;
    }
    .button-box{
      cursor: pointer;
      text-align: center;
      height: 94px;
      line-height: 94px;
      font-size: 28px;
      color: #fff;
      background-color: #000;
      border-radius: 6px;
      width: 240px;
      margin-left: 20px;
    }
    .input-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .inner-input{
        flex: 1;
        border: 1px solid #333;
        overflow: hidden;
        border-radius: 6px;
      }
    }
    .conditions .conditions-label{
      color: #1989fa;
      text-decoration: underline;
    }
  }
}
.footer {
  background: #F0F0F0;
  margin: auto;
  padding: 60px 0;
  overflow: hidden;
}

.navfooter {
  padding: 0;
  margin: 0 auto;
  width: var(--viewport-width);
  position: relative;
  font-size: 28px;
  height: 600px;
}

.navfooter ul {
  padding: 0;
  margin: 0;
  height: 100%;
  /* font-weight:bold; */
  color: #333;
}

.footerleft > div.footeritem:nth-child(4) {
  /* flex: 0; */
  padding-left: 40px;
}

.navfooterhead {
  font-weight: 700;
  color: #333;
  font-size: 36px;
}

.footerleft .footeritem ul li:hover {
  text-decoration: underline;
  cursor: pointer;
}

.navfooter .footerleft {
  display: flex;
  justify-content: space-between;
  line-height: 56px;
}

.navfooter .footerleft .footeritem {
  text-align: left;
}

.footerleft .navfooterhead {
  padding-bottom: 40px;
}

.stay-connected {
  display: flex;
  border-bottom: 1px solid #D9D9D9;
  align-items: center;
  width: var(--viewport-width);
  margin: 0 auto;
  padding: 40px 0;
  margin-bottom: 40px;;

  .title-text {
    font-size: 36px;
    color: #333;
    font-weight: 600;
  }

  .download-app {
    margin-left: 200px;
  }

  .google-play-icon {
    display: inline-block;
    margin-left: 40px;;
    height: 60px;
  }

  .stay-icons {
    display: flex;

    img {
      margin: 0 30px;
      width: 60px;
      height: 60px;
    }
  }
}


.googleplay {
  width: 228px;
  height: 48px;
  line-height: 48px;
  background: url(https://image.kilimall.com/kenya/PcImages/footerappad/google_play.png?v=20180806001);
  background-repeat: no-repeat;
  margin-bottom: 16px;
  /* margin: 0 auto; */
}

.googleplay a {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.appPromo .raddo {
  margin-top: -26px;
}

.supportedPayment {
  width: var(--viewport-width);
  border: 2px #eaeaea;
  margin-top: 60px;
  margin: auto;
}
.brand-div {
  width: var(--viewport-width);
  margin: 0 auto;
  margin-top: 60px;
  padding-bottom: 20px;
  display: flex;
  .brand-item {
    width: 100px;
    flex: 1;
    .brand-title {
      display: block;
      line-height: 60px;
      font-size: 24px;
    }
  }
}

.supportedPayment:deep(.paymentICONLIST) {
  display: flex;
  margin-bottom: 20px;
}

.paymentICONLIST li {
  flex: 1;
}

.paymentICONLIST li img {
  width: 174px;
  height: 86px;
  display: block;
}

.spwrapper1 {
  font-size: 36px;
  font-weight: bold;
  padding: 58px 0px 40px 0px;
}

.supportedPayment .banner {
  width: var(--viewport-width);
  margin: 0 auto;
}

.spTitle1 {
  font-size: 36px;
  font-weight: bold;
  margin: 20px 0;
}

.soild {
  height: 2px;
  border-bottom: 2px solid #eaeaea;
}

.wrapper {
  font-size: 24px;
  padding: 60px 0;
  width: var(--viewport-width);
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  color: #333;
  line-height: 32px;
}

.copyright {
  font-size: 24px;
  color: #999;
  text-align: center;
  padding: 30px 0;
}
</style>
